<template>
  <div class="mt-5">
    <vs-tabs alignment="fixed">
      <!-- Final Pay Reports -->
      <vs-tab
        label="Final Pay Reports"
        icon-pack="feather"
        icon="icon-calendar"
      >
        <vx-card
          title="Final Pay Reports"
          subtitle="Generate Final Pay Reports"
          class="app-fixed-height"
        >
          <div class="vx-col w-full mb-base">
            <FinalPayReport />
          </div>
        </vx-card>
      </vs-tab>
      <!-- END Final Pay Reports  -->
    </vs-tabs>
  </div>
</template>
<script>
import FinalPayReport from "./FinalPayReport.vue";
export default {
  components: {
    FinalPayReport,
  },
  data() {
    return {};
  },
  created() {
    this.$store
      .dispatch("hrms/getAllEmployee", data)
      .then((res) => {
        this.$vs.loading.close();
      })
      .catch((err) => {
        console.error(err);
      });
  },
  computed: {},
};
</script>
